// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-grey {
  background-color: #F4F7F8;
  border-radius: 6px;
  padding: 15px;
  margin-bottom: 24px;
}
.container-grey .form-group:last-child {
  min-height: auto;
  margin-bottom: auto;
}

.green-text-container {
  padding: 20px 0px;
  text-align: right;
}

a.green-text {
  cursor: pointer;
  font-weight: unset;
  text-decoration: none;
  text-align: right;
}
a.green-text .arrow-green {
  background-image: url("https://static.fif.tech/onboarding-peru-cuentas-assets/accounts/assets/icons/generic/arrow-down-green.svg");
  background-repeat: no-repeat;
  display: inline-block;
  height: 8px;
  width: 10px;
  margin-left: 5px;
}
a.green-text .arrow-green.open {
  background-image: url("https://static.fif.tech/onboarding-peru-cuentas-assets/accounts/assets/icons/generic/arrow-up-green.svg");
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
